
import { normalize_user_role } from '@/utils/constants/constants.js';

export default {
  name: 'UserLogin',
  components: {},
  data() {
    var data = {

    };

    return data;
  },

  mounted() {
    this.fetch_auth_token();
  },

  methods: {

    fetch_auth_token() {
      var token = this.$route.params.token;
      var user_id = this.$route.params.user_id;
      var user_role = this.$route.params.user_role;
      var is_aic_one_login = this.$route.params.is_aic_one_login;
      var current_system = this.$route.params.current_system;

      if (token && user_id && user_role) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_id', user_id);
        sessionStorage.setItem('otp_verified', true);
        sessionStorage.setItem('is_lead', 'false');
        sessionStorage.setItem('lead_id', null);
        sessionStorage.setItem('user_role', normalize_user_role(user_role));
        sessionStorage.setItem('is_aic_one_login', is_aic_one_login);
        sessionStorage.setItem('current_platform', current_system);

        if (user_role === "System Admin") {
          window.location.href = escape('/company_management');
        }
        else {
          window.location.href = escape('/view_all_user_forms');
        }
      }
      else {
        console.log("no user")
      }
    }
  }
}